enum AppLocale {
  RU = 'ru',
  EN = 'en',
}

export { AppLocale };
